import React, { useState } from 'react';

import Button from 'components/Button';
import FormNavigation from 'components/FormNavigation';
import SelectableCard from 'components/Common/SelectableCard';
import FormContainer from 'components/LoanForm/FormContainer';

import { FlowComponentType } from 'routes/types';
import { WhatIsTheIssueResult } from 'enums/FlowNextResults';

import styles from './WhatIsTheIssue.module.scss';

interface IssueOption {
  id: WhatIsTheIssueResult;
  title: string;
  subtitle?: string;
}

const WhatIsTheIssue = ({ navigationInfo, handleNext }: FlowComponentType) => {
  const [optionSelected, setOptionSelected] = useState<WhatIsTheIssueResult>();

  const issueOptions: IssueOption[] = [
    {
      id: WhatIsTheIssueResult.EmployerRestriction,
      title: 'My employer does not allow me to add new direct deposit accounts.',
    },
    {
      id: WhatIsTheIssueResult.RoutingNumberNotRecognized,
      title: 'Got an error that the routing number was not recognized.',
    },
    {
      id: WhatIsTheIssueResult.Other,
      title: 'Other',
    },
  ];

  const handleContinue = () => {
    handleNext(optionSelected);
    analytics.track('New Setup Deduction - What Is The Issue Screen', {
      optionSelected,
    });
  };

  return (
    <>
      <FormNavigation {...navigationInfo} />
      <FormContainer title="What is the issue?">
        <div className={styles.content}>
          {issueOptions.map((option) => (
            <SelectableCard
              key={option.id}
              selected={optionSelected === option.id}
              onClick={() => setOptionSelected(option.id)}
              title={option.title}
              subtitle={option.subtitle}
            />
          ))}
        </div>
        <Button onClick={handleContinue} disabled={!optionSelected}>
          Next
        </Button>
      </FormContainer>
    </>
  );
};

export default WhatIsTheIssue;
